import { render, staticRenderFns } from "./edit-phone-contact-modal.vue?vue&type=template&id=e8c0bf9a&lang=pug"
import script from "./edit-phone-contact-modal.vue?vue&type=script&lang=js"
export * from "./edit-phone-contact-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports